import React from "react";

interface RangeSliderWrapperProps {
    title: string;
    children: any;
    values: any;
    checkTitle?: (value: number) => string | undefined;
}

export default function RangeSliderWrapper(props: RangeSliderWrapperProps) {

    var title = props.title;
    var value = props.values[Object.keys(props.values)[0]];
    if(props.checkTitle) {
        title = props.checkTitle(value) || title;
    }

    for(var key in props.values) {
        title = title.replace("{"+key+"}", props.values[key]);
    }

    return <div className="range-slider-wrapper">
            <a>{title}</a>
            <div className="range-slider">
                {props.children}
                <div className="active-line"/>
            </div>
            
        </div>;

}